var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{class:{'red':_vm.buttonStyle ==='red'
    ,'blue':_vm.buttonStyle==='blue'
    ,'green':_vm.buttonStyle==='green'},on:{"click":_vm.clickEvent}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }